import { c as _c } from "react/compiler-runtime";
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import type { ApplyNowButtonProps } from 'src/features/product-card/ApplyNowButton';
import { ApplyNowButton } from 'src/features/product-card/ApplyNowButton';
type DeviceType = Pick<ApplyNowButtonProps, 'device'>;
export default function ReviewProductCardApplyNowButton(t0) {
  const $ = _c(16);
  const {
    device
  } = t0;
  const {
    marketplaceEntity
  } = useReviewContext();
  const {
    details: t1,
    institution: t2,
    name,
    displayName,
    ctaAnalytics
  } = marketplaceEntity;
  const {
    applyLink,
    applyPhoneNumber,
    isActive,
    isMonetizing,
    reviewLink,
    versionId
  } = t1;
  const {
    name: institutionName
  } = t2;
  let t3;
  if ($[0] !== ctaAnalytics.section) {
    t3 = {
      ...ctaAnalytics.section,
      name: "review_product_card"
    };
    $[0] = ctaAnalytics.section;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== ctaAnalytics || $[3] !== t3) {
    t4 = {
      ...ctaAnalytics,
      section: t3,
      linkType: "APPLY_NOW_BUTTON"
    };
    $[2] = ctaAnalytics;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = displayName || name;
  let t6;
  if ($[5] !== applyLink || $[6] !== applyPhoneNumber || $[7] !== device || $[8] !== institutionName || $[9] !== isActive || $[10] !== isMonetizing || $[11] !== reviewLink || $[12] !== t4 || $[13] !== t5 || $[14] !== versionId) {
    t6 = <ApplyNowButton analytics={t4} id="product-card-apply-now" isActive={isActive} isMonetizing={isMonetizing} applyLink={applyLink} reviewLink={reviewLink} applyPhoneNumber={applyPhoneNumber} institutionName={institutionName} ctaType="APPLY_NOW_BUTTON" versionId={versionId} linkSx={_temp} device={device} name={t5} />;
    $[5] = applyLink;
    $[6] = applyPhoneNumber;
    $[7] = device;
    $[8] = institutionName;
    $[9] = isActive;
    $[10] = isMonetizing;
    $[11] = reviewLink;
    $[12] = t4;
    $[13] = t5;
    $[14] = versionId;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
function _temp(t0) {
  const {
    palette: t1
  } = t0;
  const {
    primary
  } = t1;
  return {
    "&:hover": {
      backgroundColor: primary.dark
    }
  };
}